// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  SimpleGrid,
  Text,
  Tooltip,
  useColorModeValue,
  useDisclosure,
  usePrevious,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import Information from "views/admin/profile/components/Information";
import { useDispatch, useSelector } from "react-redux";
import { RootReducer } from "../../../../RootReducer";
import React, { useEffect, useState } from "react";
import {
  PersistAccountDetailsAction,
  PersistChangedPasswordAction,
} from "../../../../listener/signin/action";
import InvoiceModal from "views/admin/profile/components/InvoiceModal";
import { Link, useHistory } from "react-router-dom";

// Assets
export default function AccountDetails(props: { [x: string]: any }) {
  const { ...rest } = props;
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const history = useHistory();

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");

  const couponValue = useSelector(
    (state: RootReducer) => state.authentication.couponAmountRemaining
  );
  const accountInfo = useSelector(
    (state: RootReducer) => state.authentication.accountInfo
  );

  const accountInfoPersistRequestState = useSelector(
    (state: RootReducer) => state.authentication.accountDetailsRequestState
  );
  const changePasswordRequestState = useSelector(
    (state: RootReducer) => state.authentication.changePasswordRequestState
  );
  const previousChangePasswordRequestState = usePrevious(
    changePasswordRequestState
  );

  const [companyName, setCompanyName] = useState<string>("");
  const [companyCity, setCompanyCity] = useState<string>("");
  const [companyCountry, setCompanyCountry] = useState<string>("");
  const [companyStreet, setCompanyStreet] = useState<string>("");
  const [companyPostalCode, setCompanyPostalCode] = useState<string>("");
  const [companyVatId, setCompanyVatId] = useState<string>("");

  const [password, setPassword] = useState<string>("");
  const [repeatPassword, setRepeatPassword] = useState<string>("");
  const [updatedPassword, setUpdatedPassword] = useState<string>("");

  const isSpecialMode = localStorage.getItem("s") === "1";

  useEffect(() => {
    if (accountInfo) {
      setCompanyName(accountInfo.companyName);
      setCompanyCity(accountInfo.companyCity);
      setCompanyCountry(accountInfo.companyCountry);
      setCompanyStreet(accountInfo.companyStreet);
      setCompanyPostalCode(accountInfo.companyPostalCode);
      setCompanyVatId(accountInfo.companyVatId);
    }
  }, [accountInfo, dispatch]);

  useEffect(() => {
    if (
      previousChangePasswordRequestState &&
      previousChangePasswordRequestState.isLoading &&
      changePasswordRequestState.isSuccessful
    ) {
      setPassword("");
      setRepeatPassword("");
      setUpdatedPassword("");
    }
  }, [previousChangePasswordRequestState, changePasswordRequestState]);

  if (!accountInfo) {
    return null;
  }

  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="2xl">
        <InvoiceModal onClose={onClose} />
      </Modal>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Details
      </Text>
      <SimpleGrid columns={2} gap="20px">
        <Information title="Mail" value={accountInfo.mail} />
        <Information title="API Key" value={accountInfo.apiKey} />
        {/*<Information boxShadow={cardShadow} title='MMP' value={} />*/}
      </SimpleGrid>
      <Text
        style={{ marginTop: 30 }}
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Payment
      </Text>
      <SimpleGrid columns={1} gap="20px">
        <Information title="Invoice" value={"Net 30"} />
        <Flex>
          <Button
            as={Link}
            to="/invoices"
            disabled={false}
            style={{
              marginRight: "10px",
              color: "white",
              borderColor: "#4a34ff",
              borderWidth: 2,
              backgroundColor: "#4a34ff",
            }}
            variant="solid"
            size="lg"
          >
            <Text>View Unpaid & Overdue Invoices</Text>
          </Button>

          {isSpecialMode && (
            <Tooltip title={"No Invoice available yet"}>
              <Button
                onClick={onOpen}
                style={{
                  color: "#4a34ff",
                  borderColor: "#4a34ff",
                  borderWidth: 2,
                  width: 200,
                }}
                variant="solid"
                size="lg"
              >
                <Text>Download Invoices</Text>
              </Button>
            </Tooltip>
          )}
        </Flex>
      </SimpleGrid>
      <SimpleGrid columns={1} gap="20px">
        <Text
          fontWeight="bold"
          color={textColorPrimary}
          fontSize="2xl"
          mt="60px"
          mb="12px"
        >
          Company
        </Text>

        <SimpleGrid
          columns={2}
          spacing={14}
          marginLeft="14px"
          marginRight="20px"
        >
          <SimpleGrid columns={2} spacing={4}>
            <FormControl isRequired={true}>
              <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
                Company Name
              </FormLabel>
              <Input
                autoComplete={"pleaseno"}
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                placeholder={"Name"}
                value={companyName}
                onChange={(c) => setCompanyName(c.target.value)}
                mb="24px"
                fontWeight="500"
                size="lg"
                isDisabled
              />
            </FormControl>
            <FormControl isRequired={true}>
              <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
                City
              </FormLabel>
              <Input
                autoComplete={"pleaseno"}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                placeholder={"City"}
                value={companyCity}
                onChange={(c) => setCompanyCity(c.target.value)}
                mb="24px"
                fontWeight="500"
                size="lg"
                isDisabled
              />
            </FormControl>
          </SimpleGrid>
          <SimpleGrid columns={2} spacing={4}>
            <div>
              <FormControl isRequired={true}>
                <FormLabel
                  fontSize={"sm"}
                  fontWeight="medium"
                  color={"gray.400"}
                >
                  Postal Code
                </FormLabel>
                <Input
                  autoComplete={"pleaseno"}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  placeholder={"Postal Code"}
                  value={companyPostalCode}
                  onChange={(c) => setCompanyPostalCode(c.target.value)}
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                  isDisabled
                />
              </FormControl>
            </div>
            <div>
              <FormControl isRequired={true}>
                <FormLabel
                  fontSize={"sm"}
                  fontWeight="medium"
                  color={"gray.400"}
                >
                  Country
                </FormLabel>
                <Input
                  autoComplete={"pleaseno"}
                  isRequired={true}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  placeholder={"Country"}
                  value={companyCountry}
                  onChange={(c) => setCompanyCountry(c.target.value)}
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                  isDisabled
                />
              </FormControl>
            </div>
          </SimpleGrid>
        </SimpleGrid>
        <SimpleGrid
          columns={2}
          spacing={14}
          marginLeft="14px"
          marginRight={"20px"}
        >
          <div>
            <FormControl isRequired={true}>
              <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
                Street
              </FormLabel>
              <Input
                autoComplete={"pleaseno"}
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                placeholder={"Street"}
                value={companyStreet}
                onChange={(c) => setCompanyStreet(c.target.value)}
                mb="24px"
                fontWeight="500"
                size="lg"
                isDisabled
              />
            </FormControl>
          </div>
          <div>
            <FormControl>
              <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
                VAT ID
              </FormLabel>
              <Input
                name="vatId"
                type={"text"}
                autoComplete={"pleaseno"}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                placeholder={"VAT ID"}
                value={companyVatId}
                onChange={(c) => setCompanyVatId(c.target.value)}
                mb="24px"
                fontWeight="500"
                size="lg"
                isDisabled
              />
            </FormControl>
          </div>
        </SimpleGrid>
        {/* 
        <SimpleGrid columns={1} spacing={4}>
          <Flex>
            <Button
              onClick={() => {
                dispatch(
                  PersistAccountDetailsAction(
                    companyName,
                    companyStreet,
                    companyCity,
                    companyPostalCode,
                    companyCountry,
                    companyVatId
                  )
                );
              }}
              isLoading={accountInfoPersistRequestState.isLoading}
              disabled={false}
              style={{
                marginRight: "10px",
                color: "white",
                borderColor: "#4a34ff",
                borderWidth: 2,
                backgroundColor: "#4a34ff",
              }}
              variant="solid"
              size="lg"
            >
              <Text>Save Details</Text>
            </Button>
          </Flex>
        </SimpleGrid> */}
      </SimpleGrid>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="60px"
        mb="20px"
      >
        Password
      </Text>
      <SimpleGrid columns={2} gap="20px">
        <FormControl isRequired={true}>
          <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
            Old Password
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            placeholder={"Old Password"}
            value={password}
            type={"password"}
            onChange={(c) => setPassword(c.target.value)}
            mb="24px"
            fontWeight="500"
            size="lg"
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={2} gap="20px">
        <FormControl isRequired={true}>
          <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
            New Password
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            placeholder={"New Password"}
            type={"password"}
            value={updatedPassword}
            onChange={(c) => setUpdatedPassword(c.target.value)}
            mb="24px"
            fontWeight="500"
            size="lg"
          />
        </FormControl>
        <FormControl isRequired={true}>
          <FormLabel fontSize={"sm"} fontWeight="medium" color={"gray.400"}>
            Repeat New Password
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            placeholder={"Repeat New Password"}
            value={repeatPassword}
            type={"password"}
            onChange={(c) => setRepeatPassword(c.target.value)}
            mb="24px"
            fontWeight="500"
            size="lg"
          />
        </FormControl>
      </SimpleGrid>
      <Button
        onClick={() => {
          dispatch(PersistChangedPasswordAction(password, updatedPassword));
        }}
        isLoading={changePasswordRequestState.isLoading}
        disabled={
          updatedPassword !== repeatPassword ||
          password === "" ||
          repeatPassword === "" ||
          updatedPassword === ""
        }
        style={{
          marginTop: "10px",
          marginBottom: "20px",
          marginRight: "10px",
          color: "white",
          borderColor: "#4a34ff",
          borderWidth: 2,
          backgroundColor: "#4a34ff",
          width: 200,
        }}
        color={"#4a34ff"}
        variant="solid"
        size="lg"
      >
        <Text style={{ color: "white" }}>Update Password</Text>
      </Button>
    </Card>
  );
}
